import React from 'react';
import {REMINDERS} from "entities/constants/constants";
import {Link} from "react-router-dom";
import {Notification} from "entities/Profile/model/types/profile";


type InfoCardData = {
    notifications?: Notification[]
}

export const InfoCard = ({notifications}: InfoCardData) => {

    if (!notifications || notifications.length === 0) {
        return null;
    }

    return (
        <div className="info-card">
            <div className="info-card-hdr">
                <div className="title-box">
                    <p className="info-card-title h6">{REMINDERS}</p>
                </div>
            </div>
            <div className="info-card-content large-row-indent">
                {notifications?.map((notification, index) => (
                    <div className="row" key={index}>
                        {notification.type === 'test' && (
                            <div className="inline-text-btn">
                                <p>{notification.text}</p>
                                <Link className='btn secondary small in-text'
                                      to={`/test/${notification.idTest}`}><span>Пройти сейчас</span></Link>
                            </div>
                        )}
                        {notification.type === 'restClasses' && (
                            <div className="row">
                                <p>{notification.text}
                                    <span className="btn secondary small in-text">
                                            <span>
                                                <Link style={{boxShadow: 'none'}}
                                                      to={`/buy-course`}>{notification.count}</Link>
                                            </span>
                                        </span>
                                </p>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

